import { render, staticRenderFns } from "./PanelCompetitionInsurance.vue?vue&type=template&id=9414f896&scoped=true&"
import script from "./PanelCompetitionInsurance.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionInsurance.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionInsurance.vue?vue&type=style&index=0&id=9414f896&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9414f896",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9414f896')) {
      api.createRecord('9414f896', component.options)
    } else {
      api.reload('9414f896', component.options)
    }
    module.hot.accept("./PanelCompetitionInsurance.vue?vue&type=template&id=9414f896&scoped=true&", function () {
      api.rerender('9414f896', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PanelCompetitionInsurance.vue"
export default component.exports